import { render, staticRenderFns } from "./massive-projects.vue?vue&type=template&id=1b3134f6&"
import script from "./massive-projects.vue?vue&type=script&lang=js&"
export * from "./massive-projects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports